// extracted by mini-css-extract-plugin
export default {"disabled":"PaginationItem_disabled__O6m28","paginationItems":"PaginationItem_paginationItems__3umO1","paginationItemsCurrent":"PaginationItem_paginationItemsCurrent__H92Gt"};